import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import {
    EmbargoType,
} from 'app/enums/label.enums'

import requests from 'app/requests/RateCard/RateCard.requests'
import {
    EmbargoContriesTable,
} from './EmbargoContries.types'

const config: SkyNetTableTab<keyof EmbargoContriesTable> = {
    name: 'Embargo Countries',
    url: RateCardsTabs.EmbargoCountries,
    customUrl: requests.embargoCountriesFilterRequest().url,
    fields: [
        {
            name: 'countryCountryName',
            labelKey: 'EmbargoCountries.countryName',
        },
        {
            name: 'embargoType',
            componentName: 'EnumValue',
            allowedValuesEnum: EmbargoType,
            labelKey: 'EmbargoCountries.embargoType',
        },
    ],
    exclude: {
        tableControls: [TableControlTypes.BulkEdit],
    },
}

export default config
